"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12.838 10l-9.154 3.051a1 1 0 00.632 1.898l12-4c.912-.304.912-1.594 0-1.898l-12-4a1 1 0 00-.632 1.898L12.838 10z"];
//# sourceMappingURL=greater-than.js.map